import { createTheme } from '@mui/material/styles';
import { red } from '@mui/material/colors';

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      main: '#A3C6C4',
    },
    secondary: {
      main: '#D8A0C0',
    },
    error: {
      main: red['500'],
    },
    background: {
      default: '#FFF9F8',
    }
  },
});

export default theme;
